export function nextAutoPaymentIndex(lineCount, editedIndex) {
  if (lineCount < 2) return 0;
  return (editedIndex + 1) % lineCount;
}

export function calculateSplitPayment(lines, total, autoIndex, allowCredit = false) {
  const target = Math.max(0, Number(total || 0));
  const safeAutoIndex = Math.min(Math.max(0, Number(autoIndex) || 0), Math.max(0, lines.length - 1));
  let manualTotal = 0;
  const amounts = lines.map((line, index) => {
    if (!allowCredit && index === safeAutoIndex) return 0;
    const amount = Math.max(0, Number(line.amount || 0));
    manualTotal += amount;
    return amount;
  });
  if (!allowCredit && amounts.length) amounts[safeAutoIndex] = Math.max(0, target - manualTotal);
  const paid = amounts.reduce((sum, amount) => sum + amount, 0);
  return {
    amounts,
    manualTotal,
    paid,
    credit: Math.max(0, target - paid),
    valid: amounts.length >= 2 && Number.isFinite(paid) && manualTotal <= target && (allowCredit || Math.abs(paid - target) < 1),
  };
}
